import styles from '~/styles/atoms/row/row.module.scss'
import { ChildProps } from '~/common/define/props'
import { MutableRefObject, UIEventHandler } from 'react'
import { addClass } from '~/common/utils/html'

export enum RowListScroll {
  NO,
  MIDDLE,
  MAX
}

interface Props extends ChildProps {
  onScroll?: UIEventHandler<HTMLUListElement>
  listRef?: MutableRefObject<any>
  noBorder?: boolean
  scroll?: RowListScroll
}

const RowList = ({children, onScroll = null, listRef = null, noBorder = false, scroll = RowListScroll.MIDDLE}: Props) => {
  return (
    <ul
      className={styles.row__list + addClass(styles.row__list__border, !noBorder)
        + addClass(scroll == RowListScroll.NO ? styles.scrollNo : scroll == RowListScroll.MIDDLE ? styles.scrollMiddle : styles.scrollMax)}
      onScroll={onScroll} ref={listRef}
    >
      {children}
    </ul>
  )
}

export default RowList